<template>
  <div
    v-if="
      listing && (listing.status === 'active' || listing.status === 'booked')
    "
    class="listing-outputs-wrapper"
  >
    <div class="listing-outputs">
      <div
        @click.stop="openMarketplaceURL(marketplace)"
        @mouseover="hoveredItem = marketplace.name"
        @mouseleave="hoveredItem = null"
        v-for="marketplace in listing.marketplaces?.filter((mp) => !mp.hidden)"
        :key="marketplace.name"
        :class="{
          'listing-output-pending':
            marketplace.isActive &&
            (marketplace.pendingUntil ||
              (listing.city24BrokerError && marketplace.name === 'city24')),
          'listing-output-active':
            marketplace.isActive && !marketplace.pendingUntil,
          'listing-output-inactive': !marketplace.isActive,
        }"
        class="listing-output"
      >
        <svg
          v-if="
            marketplace.url &&
            (!listing.city24BrokerError ||
              (listing.city24BrokerError && marketplace.name !== 'city24'))
          "
          width="12"
          height="12"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
          class="icon-svg"
          :style="{
            fill:
              hoveredItem === marketplace.name
                ? '#ffffff'
                : !marketplace.isActive
                  ? '#FF1E24'
                  : '#0AAF60',
          }"
        >
          <path
            d="M14.166 11.6667C14.6263 11.6667 14.9993 12.0398 14.9993 12.5001C14.9993 12.9603 14.6263 13.3334 14.166 13.3334C13.7058 13.3334 13.3327 12.9603 13.3327 12.5001C13.3327 12.0398 13.7058 11.6667 14.166 11.6667Z"
          />
          <path
            d="M14.166 14.1667C14.6263 14.1667 14.9993 14.5398 14.9993 15.0001C14.9993 15.4603 14.6263 15.8334 14.166 15.8334C13.7058 15.8334 13.3327 15.4603 13.3327 15.0001C13.3327 14.5398 13.7058 14.1667 14.166 14.1667Z"
          />
          <path
            d="M7.49935 5.00008C7.95959 5.00008 8.33268 5.37318 8.33268 5.83342C8.33268 6.29365 7.95959 6.66675 7.49935 6.66675H5.83268C5.37245 6.66675 4.99935 6.29365 4.99935 5.83342C4.99935 5.37318 5.37245 5.00008 5.83268 5.00008H7.49935Z"
          />
          <path
            d="M7.49935 8.33342C7.95959 8.33342 8.33268 8.70651 8.33268 9.16675C8.33268 9.62699 7.95959 10.0001 7.49935 10.0001H5.83268C5.37245 10.0001 4.99935 9.62699 4.99935 9.16675C4.99935 8.70651 5.37245 8.33342 5.83268 8.33342H7.49935Z"
          />
          <path
            d="M7.49935 11.6667C7.95959 11.6667 8.33268 12.0398 8.33268 12.5001C8.33268 12.9603 7.95959 13.3334 7.49935 13.3334H5.83268C5.37245 13.3334 4.99935 12.9603 4.99935 12.5001C4.99935 12.0398 5.37245 11.6667 5.83268 11.6667H7.49935Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.16602 18.3334C2.7853 18.3334 1.66602 17.2141 1.66602 15.8334V4.16675C1.66602 2.78604 2.7853 1.66675 4.16602 1.66675H9.16602C10.5467 1.66675 11.666 2.78604 11.666 4.16675V8.33342H15.8327C17.2134 8.33342 18.3327 9.4527 18.3327 10.8334V15.8334C18.3327 17.2141 17.2134 18.3334 15.8327 18.3334H4.16602ZM15.8327 16.6667H11.666V10.0001H15.8327C16.2929 10.0001 16.666 10.3732 16.666 10.8334V15.8334C16.666 16.2937 16.2929 16.6667 15.8327 16.6667ZM9.99935 4.16675V16.6667H8.33268V15.8334C8.33268 15.3732 7.95959 15.0001 7.49935 15.0001H5.83268C5.37245 15.0001 4.99935 15.3732 4.99935 15.8334V16.6667H4.16602C3.70578 16.6667 3.33268 16.2937 3.33268 15.8334V4.16675C3.33268 3.70651 3.70578 3.33341 4.16602 3.33341H9.16602C9.62625 3.33341 9.99935 3.70651 9.99935 4.16675Z"
          />
        </svg>
        <p class="content-small">{{ marketplace.name }}</p>
      </div>
    </div>
    <div
      ref="outputSettings"
      @click="openOutputSettings"
      @mouseover="hoveredItem = 'settings'"
      @mouseleave="hoveredItem = null"
      class="settings-wheel"
    >
      <svg
        :style="{
          fill: hoveredItem === 'settings' ? '#000000' : '#808080',
        }"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.78326 14.1665C2.43099 13.5573 2.15715 12.9061 1.96826 12.2282C2.37935 12.0191 2.72459 11.7004 2.96579 11.3073C3.20698 10.9142 3.33473 10.462 3.33491 10.0008C3.33508 9.53957 3.20767 9.08731 2.96676 8.69402C2.72586 8.30073 2.38086 7.98174 1.96993 7.77235C2.34663 6.41026 3.06387 5.16648 4.05409 4.15819C4.44084 4.40962 4.88961 4.54915 5.35074 4.56134C5.81188 4.57352 6.26739 4.45788 6.66687 4.22721C7.06635 3.99655 7.39422 3.65985 7.6142 3.25439C7.83418 2.84892 7.93768 2.3905 7.91326 1.92985C9.28169 1.5762 10.7176 1.57678 12.0858 1.93152C12.0616 2.39216 12.1653 2.85051 12.3854 3.25586C12.6056 3.66121 12.9336 3.99775 13.3331 4.22824C13.7327 4.45872 14.1882 4.57418 14.6493 4.56181C15.1104 4.54945 15.5591 4.40975 15.9458 4.15819C16.4283 4.64985 16.8566 5.20902 17.2166 5.83319C17.5774 6.45735 17.8474 7.10819 18.0316 7.77152C17.6205 7.9806 17.2753 8.29933 17.0341 8.69244C16.7929 9.08555 16.6651 9.53772 16.665 9.99892C16.6648 10.4601 16.7922 10.9124 17.0331 11.3057C17.274 11.699 17.619 12.018 18.0299 12.2274C17.6532 13.5894 16.936 14.8332 15.9458 15.8415C15.559 15.5901 15.1102 15.4506 14.6491 15.4384C14.188 15.4262 13.7325 15.5418 13.333 15.7725C12.9335 16.0032 12.6056 16.3399 12.3857 16.7453C12.1657 17.1508 12.0622 17.6092 12.0866 18.0699C10.7182 18.4235 9.28224 18.4229 7.91409 18.0682C7.9383 17.6075 7.83459 17.1492 7.61445 16.7438C7.3943 16.3385 7.0663 16.002 6.66674 15.7715C6.26718 15.541 5.81164 15.4255 5.35053 15.4379C4.88943 15.4503 4.44073 15.59 4.05409 15.8415C3.56159 15.339 3.13459 14.7762 2.78326 14.1665ZM7.49993 14.3299C8.38795 14.842 9.05563 15.664 9.37493 16.6382C9.79076 16.6774 10.2083 16.6782 10.6241 16.639C10.9436 15.6647 11.6116 14.8427 12.4999 14.3307C13.3876 13.8171 14.4337 13.6494 15.4374 13.8599C15.6791 13.5199 15.8874 13.1574 16.0608 12.7782C15.377 12.0144 14.9992 11.025 14.9999 9.99985C14.9999 8.94985 15.3916 7.96902 16.0608 7.22152C15.8862 6.84248 15.677 6.48038 15.4358 6.13985C14.4327 6.35011 13.3873 6.18275 12.4999 5.66985C11.6119 5.15766 10.9442 4.33567 10.6249 3.36152C10.2091 3.32235 9.79159 3.32152 9.37576 3.36069C9.05626 4.33497 8.38826 5.15699 7.49993 5.66902C6.61225 6.18261 5.56616 6.35029 4.56243 6.13985C4.32123 6.48009 4.11254 6.84224 3.9391 7.22152C4.6229 7.98532 5.00066 8.97468 4.99993 9.99985C4.99993 11.0499 4.60826 12.0307 3.9391 12.7782C4.11365 13.1572 4.32288 13.5193 4.5641 13.8599C5.56719 13.6496 6.6126 13.817 7.49993 14.3299ZM9.99993 12.4999C9.33689 12.4999 8.701 12.2365 8.23216 11.7676C7.76332 11.2988 7.49993 10.6629 7.49993 9.99985C7.49993 9.33681 7.76332 8.70093 8.23216 8.23209C8.701 7.76324 9.33689 7.49985 9.99993 7.49985C10.663 7.49985 11.2989 7.76324 11.7677 8.23209C12.2365 8.70093 12.4999 9.33681 12.4999 9.99985C12.4999 10.6629 12.2365 11.2988 11.7677 11.7676C11.2989 12.2365 10.663 12.4999 9.99993 12.4999ZM9.99993 10.8332C10.2209 10.8332 10.4329 10.7454 10.5892 10.5891C10.7455 10.4328 10.8333 10.2209 10.8333 9.99985C10.8333 9.77884 10.7455 9.56688 10.5892 9.4106C10.4329 9.25432 10.2209 9.16652 9.99993 9.16652C9.77891 9.16652 9.56695 9.25432 9.41067 9.4106C9.25439 9.56688 9.1666 9.77884 9.1666 9.99985C9.1666 10.2209 9.25439 10.4328 9.41067 10.5891C9.56695 10.7454 9.77891 10.8332 9.99993 10.8332Z"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheOutputs",
  props: ["listing"],
  data() {
    return {
      settingsOpen: false,
      hoveredItem: null,
    };
  },
  methods: {
    openMarketplaceURL(marketplace) {
      if (this.listing.city24BrokerError && marketplace.name === "city24") {
        marketplace.url = null;
      }
      if (marketplace.url || marketplace.portalURL) {
        window.open(marketplace.url || marketplace.portalURL, "_blank").focus();
      }
    },
    openOutputSettings() {
      this.$nextTick(() => {
        const rect = this.$refs.outputSettings?.getBoundingClientRect();
        if (rect) {
          console.log("rect: ", rect);
          this.$emit("openOutputSettings", {
            x: rect.left - 300 || 0,
            y: rect.top + 32 || 0,
          });
        } else {
          console.error("outputSettings reference is not defined.");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global_variables.scss";

.listing-outputs-wrapper {
  display: flex;
  gap: 8px;
}

.listing-outputs {
  display: flex;
  gap: 2px;
}

.listing-output {
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  padding: 2px 4px;

  p {
    font-weight: 600;
  }
}

.listing-output-active {
  border: 2px solid $green;

  p {
    color: $green;
  }

  img {
    filter: invert(57%) sepia(39%) saturate(4910%) hue-rotate(116deg)
      brightness(90%) contrast(92%);
  }

  &:hover {
    background-color: $green;

    img {
      filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg)
        brightness(103%) contrast(103%);
    }

    p {
      color: white;
    }
  }
}

.listing-output-inactive {
  border: 2px solid $red;

  p {
    color: $red;
  }

  img {
    filter: invert(20%) sepia(67%) saturate(3344%) hue-rotate(345deg)
      brightness(113%) contrast(110%);
  }

  &:hover {
    background-color: $red;

    img {
      filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg)
        brightness(103%) contrast(103%);
    }

    p {
      color: white;
    }
  }
}

.listing-output-pending {
  border: 2px solid $yellow;

  p {
    color: $yellow;
  }

  img {
    filter: invert(57%) sepia(39%) saturate(4910%) hue-rotate(116deg)
      brightness(90%) contrast(92%);
  }

  &:hover {
    background-color: $yellow;

    img {
      filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg)
        brightness(103%) contrast(103%);
    }

    p {
      color: white;
    }
  }
}

.settings-wheel {
  cursor: pointer;
}
</style>
